import { Link } from "react-router-dom";
import { useState } from "react";
import { LOGO_URL, RESTAURANT } from "@/lib/constants";
import Ornament from "@/components/Ornament";

export default function Footer() {
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    const subject = encodeURIComponent("Iscrizione newsletter Pedrocchi");
    const body = encodeURIComponent(
      `Buongiorno,

vorrei iscrivermi alla newsletter del Ristorante Pedrocchi.

Email: ${email}

Grazie.`
    );
    window.location.href = `mailto:${RESTAURANT.email}?subject=${subject}&body=${body}`;
  };

  return (
    <footer className="border-t border-ink bg-paper-dark mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-4 flex flex-col items-start">
            <img src={LOGO_URL} alt="Stemma Pedrocchi" className="h-16 w-auto mb-4" />
            <div className="font-serif text-2xl">{RESTAURANT.name}</div>
            <div className="overline mt-2">Venezia · Dal 1971</div>
            <p className="text-ink-mid text-sm leading-relaxed mt-4 max-w-xs">
              Una storia di famiglia tramandata da due generazioni nel cuore di Venezia.
            </p>
          </div>

          <div className="md:col-span-5">
            <div className="overline mb-4">La nostra newsletter</div>
            <h3 className="font-serif text-3xl md:text-4xl leading-tight mb-4">
              Lasciaci la tua email
            </h3>
            <p className="text-ink-mid text-sm mb-6 max-w-md">
              Eventi, nuovi piatti di stagione, ricorrenze del locale — niente spam, solo
              piccole notizie dalla nostra cucina.
            </p>
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-4 max-w-md" data-testid="newsletter-form">
              <input
                type="email"
                required
                placeholder="la tua email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="ink-input flex-1"
                data-testid="newsletter-email-input"
              />
              <button type="submit" className="btn-primary" data-testid="newsletter-submit-button">
                Iscriviti
              </button>
            </form>
            <p className="font-mono text-[0.6rem] tracking-wider text-ink-muted mt-3">
              Si aprirà la tua app di posta con l'email già pronta da inviare.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Contatti</div>
            <address className="not-italic text-ink leading-loose">
              <div className="font-serif text-lg">{RESTAURANT.address}</div>
              <a href={`tel:${RESTAURANT.phone}`} className="block font-mono text-xs tracking-wider mt-3 hover:text-wine">{RESTAURANT.phone}</a>
              <a href={`mailto:${RESTAURANT.email}`} className="block font-mono text-xs tracking-wider hover:text-wine">{RESTAURANT.email}</a>
            </address>
            <div className="mt-6 flex flex-col gap-2">
              <Link to="/prenotazioni" className="nav-link">Prenota tavolo</Link>
              <Link to="/menu" className="nav-link">Il nostro menu</Link>
              <Link to="/storia" className="nav-link">La nostra storia</Link>
            </div>
          </div>
        </div>

        <Ornament className="!my-12" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="font-mono text-[0.65rem] tracking-[0.25em] uppercase text-ink-muted">
            © {new Date().getFullYear()} Ristorante Pedrocchi · Famiglia Puntar
          </div>
        </div>
      </div>
    </footer>
  );
}
